<template>
  <v-list
    class="py-0"
    dense
  >
    <v-list-item
      v-for="field in config.infos.find(i => i.dataset.id === id).fields"
      :key="field"
      class="px-0"
      style="min-height:24px;max-width:100%"
      two-line
    >
      <v-list-item-content class="py-1">
        <v-list-item-title>
          {{ fields[field].title || fields[field]['x-originalName'] || fields[field].key }}
        </v-list-item-title>
        <v-list-item-subtitle
          v-if="selectedInfos[id]"
          style="white-space: normal;"
        >
          {{ formatField(selectedInfos[id], fields[field]) }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { formatField } from '@data-fair/components-app/format/fields'

export default {
  props: {
    id: { type: String, required: true }
  },
  computed: {
    ...mapState(['datasets', 'selectedInfos']),
    ...mapGetters(['config']),
    fields () {
      return this.datasets[this.id].schema.reduce((a, b) => { a[b.key] = b; return a }, {})
    }
  },
  methods: {
    formatField
  }
}
</script>
